
import Icon from 'Src/js/components/Icon.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { getOfferIndicatorFromPromoOfferBucket, OfferBucketLabelMap, OfferIndicator } from 'JS/helpers/promo-helpers';
import { IPromoOffer } from 'Src/js/types/Promo';

@Component({
	name: 'TireProductPromo',
	components: {
		Icon,
	}
})
export default class TireProductPromo extends Vue {

	/* Props
	============================================*/

	@Prop({ type: Object as () => IPromoOffer, required: true })
	readonly promo: IPromoOffer;

	@Prop({ type: Boolean, default: true })
	showLabel: boolean;

	get offerIndicator(): OfferIndicator {
		return getOfferIndicatorFromPromoOfferBucket(this.promo.promoOfferBucket);
	}

	get label() {
		return OfferBucketLabelMap[this.promo.promoOfferBucket];
	}

	/* Data
	============================================*/

	/* Methods
	============================================*/

	/* Lifecycle Hooks
	============================================*/

}
